import httpRequest from '@/utils/request';

const teamUrl = '/Team';
const urlByTeamId = (teamId: string) => {
  return `/Team/${teamId}`;
};
const updateMembersUrl = (teamId: string) => {
  return `/Team/${teamId}/member`;
};
const updateManagersUrl = (teamId: string) => {
  return `/Team/${teamId}/users`;
};

export const getTeams = (params: ITeam.IRequest.IGetTeams = {}): Promise<ITeam.IResponse.IData> => {
  return httpRequest.get(teamUrl, {
    params,
  });
};
export const updateTeam = (params: ITeam.IRequest.IUpdateTeam): Promise<IResponseData.IBaseData> => {
  const url = urlByTeamId(params.teamId);
  return httpRequest.post(url, params.data);
};
export const deleteTeam = (teamId: string): Promise<IResponseData.IBaseData> => {
  const url = urlByTeamId(teamId);
  return httpRequest.delete(url);
};
export const addMembers = (params: ITeam.IRequest.IUpdateMember): Promise<IResponseData.IBaseData> => {
  const url = updateMembersUrl(params.teamId);
  return httpRequest.post(url, params.memberIds);
};
export const deleteMembers = (params: ITeam.IRequest.IUpdateMember): Promise<IResponseData.IBaseData> => {
  const url = updateMembersUrl(params.teamId);
  return httpRequest.delete(url, {
    data: params.memberIds,
  });
};
export const addManagers = (params: ITeam.IRequest.IUpdateManager): Promise<IResponseData.IBaseData> => {
  const url = updateManagersUrl(params.teamId);
  return httpRequest.post(url, params.managerIds);
};
export const deleteManagers = (params: ITeam.IRequest.IUpdateManager): Promise<IResponseData.IBaseData> => {
  const url = updateManagersUrl(params.teamId);
  return httpRequest.delete(url, {
    data: params.managerIds,
  });
};
